<template>
  <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16 cf-padding-bottom-16">
    <h2 class="cf-title cf-title--2 cf-no-wrap">
      {{ content.OpenTabPaymentMethod.title }}
    </h2>

    <cf-radio-input
      v-model="isPayNow"
      vertical
      name="paymentMethod"
      radio-style="icon-box"
      label="Payment Method"
      label-style="hidden"
      :options="options"
    />

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      :disabled="isPayNow === undefined"
      @click="handleContinue"
    >
      {{ content.OpenTabPaymentMethod.metadata.paymentMethodCta }}
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfRadioInput from '@/view/components/shared/cf-radio-input/index.vue';


  export default {
    name: 'OpenTabFinishOrdering',

    components: {
      CfRadioInput
    },

    data() {
      return {
        isPayNow: undefined
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('orders', ['order']),
      ...mapGetters('session', ['session']),

      options() {
        return [
          {
            value: true,
            display: this.content.OpenTabPaymentMethod.metadata.checkoutTitle,
            subDisplay: this.content.OpenTabPaymentMethod.metadata.checkoutSubtitle,
            icon: 'fa-credit-card-front'
          },
          {
            value: false,
            display: this.content.OpenTabPaymentMethod.metadata.openTabTitle,
            subDisplay: this.content.OpenTabPaymentMethod.metadata.openTabSubtitle,
            icon: 'fa-file-alt'
          }
        ];
      }
    },

    methods: {
      handleContinue() {
        this.$closeAllModals();

        if (this.isPayNow) {
          this.$router.push({
            name: 'payAtTableCheckout',
            params: {
              merchantId: this.$route.params.merchantId
            },
            query: {
              ml: this.session.route.merchantLocationId,
              oi: this.order.orderId,
              tb: this.session.route.tableNumber
            }
          });
        }
        else {
          this.$router.push({
            name: 'orderAtTableMenu',
            params: {
              merchantId: this.$route.params.merchantId
            }
          });
        }
      }
    }
  };
</script>
